// extracted by mini-css-extract-plugin
export var big = "button-module--big--5d2e9";
export var button = "button-module--button--6a55d";
export var gradient = "button-module--gradient--5fe76";
export var marginNone = "button-module--marginNone--28a81";
export var medium = "button-module--medium--c7e4e";
export var shadow = "button-module--shadow--7cc17";